import moment from 'moment-timezone';
import { CANCELLED_APPOINMENT, SELECTION_COLORS } from './const';
export const activityLogFilterValues = [
    'calendarId',
    'startTime',
    'endTime',
    'title',
    'assignedUserId',
    'notes',
    'appoinmentStatus',
    'address',
    'google',
    'outlook',
];
export const activityLogFilterLabels = (t) => {
    return {
        calendarId: t('activity_log.calendar_update'),
        startTime: t('activity_log.start_time_update'),
        endTime: t('activity_log.end_time_update'),
        title: t('activity_log.title_update'),
        notes: t('activity_log.notes_update'),
        appoinmentStatus: t('activity_log.appointment_status_update'),
        address: t('activity_log.meeting_location_update'),
        google: t('activity_log.google_sync_update'),
        outlook: t('activity_log.outlook_sync_update'),
        assignedUserId: t('activity_log.assigned_user_update'),
    };
};
export const getRecurringFrequency = (frequency) => {
    switch (frequency) {
        case 'DAILY':
            return 'Daily';
        case 'WEEKLY':
            return 'Weekly';
        case 'MONTHLY':
            return 'Monthly';
    }
};
export const isMeetingURLValid = (url) => {
    const pattern = new RegExp('^([a-zA-Z]+:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', // fragment locator
    'i');
    // Patterns for meeting URL for zoom / google/ outlook
    const zoomPattern = /zoom.us\//i;
    const googleMeetPattern = /meet.google.com\//i;
    const outlookPattern = /outlook\.office\.com\/(?:[^/]+\/){6}join/i;
    return (pattern.test(url) &&
        (zoomPattern.test(url) ||
            googleMeetPattern.test(url) ||
            outlookPattern.test(url)));
};
export const convertAndFormatSource = (inputString) => {
    if (inputString && (inputString.includes('_') || inputString.includes('-'))) {
        // Choose the separator based on whether underscore or hyphen is present
        const separator = inputString.includes('_') ? '_' : '-';
        // Split the string into words using the chosen separator as separators
        const words = inputString.split(separator);
        // Capitalize the first letter of each word and join them with spaces
        const formattedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
        const formattedString = formattedWords.join(' ');
        return formattedString;
    }
    else {
        return inputString;
    }
};
export function convertEvents(data, timezone, userId, users) {
    try {
        const result = [];
        const i = users === null || users === void 0 ? void 0 : users.findIndex((item) => (item === null || item === void 0 ? void 0 : item.id) === userId);
        data.forEach((item, index) => {
            const isLongEvent = moment(item.endTime).diff(moment(item.startTime), 'hours') >= 24;
            const ob = {
                id: `${item.id}_fc${index}`,
                start: moment.tz(item.startTime, timezone).format(),
                isLongEvent: isLongEvent,
                end: isLongEvent && !item.isFullDay
                    ? moment.tz(item.endTime, timezone).add('1', 'day').format()
                    : moment.tz(item.endTime, timezone).format(),
                editable: isLongEvent ? false : item.local || item.status === 'booked',
                allDay: item.isFullDay || isLongEvent,
                title: (item === null || item === void 0 ? void 0 : item.title) || '(No title)',
                customColor: SELECTION_COLORS[i % SELECTION_COLORS.length],
                user_res_id: userId,
                timeString: `${moment
                    .tz(item.startTime, timezone)
                    .format('hh:mm A')} - ${moment
                    .tz(item.endTime, timezone)
                    .format('hh:mm A')}`,
                ogEvent: item,
            };
            result.push(ob);
        });
        return result;
    }
    catch (e) {
        //
    }
}
export const sample = [
    {
        start: '2023-09-14T04:00:00-07:00',
        end: '2023-09-14T05:00:00-07:00',
        title: 'Recurr test',
    },
    {
        start: '2023-09-11T20:30:00-07:00',
        end: '2023-09-11T21:00:00-07:00',
        title: 'Rehan Alam',
    },
    {
        start: '2023-09-14T03:00:00-07:00',
        end: '2023-09-14T04:00:00-07:00',
        title: 'Test',
    },
];
export const renderDropdownOption = (data, h, icon) => {
    return h('div', {
        style: 'display: flex; align-items: center; padding: 8px 12px;',
    }, [
        h(icon, {
            round: true,
            style: 'margin-right: 12px;',
            src: 'https://07akioni.oss-cn-beijing.aliyuncs.com/demo1.JPG',
        }),
        h('div', null, [
            h('div', null, [
                h('p', { depth: 2 }, { default: () => 'A worker at Hangzhou' }),
            ]),
        ]),
    ]);
};
export function changeOpacity(hexCode, opacity) {
    if (!hexCode)
        return hexCode;
    if (opacity === 0)
        return '#00000000';
    if (opacity === 1)
        return hexCode;
    opacity = Math.min(1, Math.max(0, opacity));
    hexCode = hexCode.replace(/^#/, '');
    if (hexCode.length === 8) {
        const r = parseInt(hexCode.slice(0, 2), 16);
        const g = parseInt(hexCode.slice(2, 4), 16);
        const b = parseInt(hexCode.slice(4, 6), 16);
        const newA = Math.round(opacity * 255);
        const clampedA = Math.min(255, Math.max(0, newA));
        const updatedHex = `#${r.toString(16).padStart(2, '0')}${g
            .toString(16)
            .padStart(2, '0')}${b.toString(16).padStart(2, '0')}${clampedA
            .toString(16)
            .padStart(2, '0')}`;
        return updatedHex;
    }
    else {
        const rgbHex = hexCode.slice(0, 6);
        const newA = Math.round(opacity * 255);
        const clampedA = Math.min(255, Math.max(0, newA));
        const updatedHex = `#${rgbHex}${clampedA.toString(16).padStart(2, '0')}`;
        return updatedHex;
    }
}
export function getTimeDifferenceInMin(d1, d2) {
    const t1 = moment(d1);
    const t2 = moment(d2);
    const minutes = t1.diff(t2, 'minutes');
    return Math.abs(minutes);
}
export function assignEventColor(arr, type) {
    if (!arr)
        return;
    if (!Array.isArray(arr))
        return;
    const result = arr.map((item, index) => {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, item), { eventColor: SELECTION_COLORS[index % SELECTION_COLORS.length] }), (type === 'calendar' && {
            name: `${!item.isActive ? '(Drafted)' : ''} ${item.name}`,
        })), (type === 'group' && {
            calendarProviderName: `${!item.isActive ? '(Drafted)' : ''} ${item.calendarProviderName}`,
        }));
    });
    return type
        ? result.sort((a, b) => {
            const isActiveComparison = b.isActive - a.isActive;
            return isActiveComparison !== 0 ? isActiveComparison : 0;
        })
        : result;
}
export function showViewAppointment(e, tz, state, data) {
    if (!e || Object.keys(e).length === 0)
        return {};
    if ('icloud' in e.extendedProps.ogEvent)
        return {};
    const appointment = Object.assign(Object.assign(Object.assign({}, e.extendedProps.ogEvent), data), { eventId: e.extendedProps.ogEvent.id, contactId: e.extendedProps.ogEvent.contactId, calendarId: e.extendedProps.ogEvent.calendarId, locationId: e.extendedProps.ogEvent.locationId, webinarId: e.extendedProps.ogEvent.webinarId, timeZone: tz, source: 'calendar_page' });
    state.viewAppointmentModal.show = true;
    state.viewAppointmentModal.data = appointment;
}
export function getStartDayOfWeek(v) {
    if (v == 1)
        return 0 * 1;
    if (v == 0)
        return 6 * 1;
    if (v == 6)
        return 5 * 1;
}
export function convertClassEvents(events, calendars, activeView) {
    const eventMap = new Map();
    const nonWebinarEvents = [];
    events.forEach((item) => {
        var _a, _b, _c, _d, _e, _f;
        switch (activeView) {
            case 'user':
                // item.resourceIds = item.ogEvent.users || [item.ogEvent.assignedUserId]
                // item.resourceId = item.ogEvent.assignedUserId
                // item.resourceId = item.customColor
                item.resourceId = item.user_res_id;
                break;
            case 'calendar':
                item.resourceId = item.ogEvent.calendarId;
                break;
            case 'group':
                item.resourceId = item.ogEvent.groupId;
                break;
        }
        const calendar = calendars.find(x => x.id === item.ogEvent.calendarId) || {};
        if (item === null || item === void 0 ? void 0 : item.ogEvent.webinarId) {
            //
            if ((item === null || item === void 0 ? void 0 : item.ogEvent.appointmentStatus) != CANCELLED_APPOINMENT) {
                item.title = ((_a = calendar === null || calendar === void 0 ? void 0 : calendar.eventTitle) === null || _a === void 0 ? void 0 : _a.includes('{{'))
                    ? 'Class booking'
                    : item === null || item === void 0 ? void 0 : item.title;
                const tempEvent = eventMap.get(item === null || item === void 0 ? void 0 : item.ogEvent.webinarId) || item;
                tempEvent.ogEvent.count = (tempEvent === null || tempEvent === void 0 ? void 0 : tempEvent.ogEvent.count)
                    ? tempEvent.ogEvent.count
                    : 0;
                tempEvent.ogEvent.appointmentIds = (tempEvent === null || tempEvent === void 0 ? void 0 : tempEvent.ogEvent.appointmentIds)
                    ? tempEvent === null || tempEvent === void 0 ? void 0 : tempEvent.ogEvent.appointmentIds
                    : [];
                if (!((_b = tempEvent === null || tempEvent === void 0 ? void 0 : tempEvent.ogEvent) === null || _b === void 0 ? void 0 : _b.appointmentIds.includes(item === null || item === void 0 ? void 0 : item.ogEvent.id))) {
                    const guestCount = ((_d = (_c = item === null || item === void 0 ? void 0 : item.ogEvent) === null || _c === void 0 ? void 0 : _c.guests) === null || _d === void 0 ? void 0 : _d.length) || (item === null || item === void 0 ? void 0 : item.ogEvent.guestCount) || 0;
                    tempEvent.ogEvent.count = ((_e = tempEvent === null || tempEvent === void 0 ? void 0 : tempEvent.ogEvent) === null || _e === void 0 ? void 0 : _e.count) + guestCount + 1;
                    tempEvent.ogEvent.appointmentIds.push((_f = item === null || item === void 0 ? void 0 : item.ogEvent) === null || _f === void 0 ? void 0 : _f.id);
                }
                tempEvent.ogEvent.totalSeat = calendar.appoinmentPerSlot;
                tempEvent.title = `${tempEvent.ogEvent.count}/${tempEvent.ogEvent.totalSeat}  ${item === null || item === void 0 ? void 0 : item.title}`;
                tempEvent.id = `${item.ogEvent.webinarId}`;
                tempEvent.editable = false;
                eventMap.set(item === null || item === void 0 ? void 0 : item.ogEvent.webinarId, tempEvent);
            }
        }
        else {
            nonWebinarEvents.push(item);
        }
    });
    const final = [...Array.from(eventMap.values()), ...nonWebinarEvents];
    return final;
}
export function retainDateFromTimeZoneChange(date, localTimeZone, targetTimeZone) {
    const date1 = moment.tz(date, localTimeZone).get('date');
    const month1 = moment.tz(date, localTimeZone).get('month');
    const year1 = moment.tz(date, localTimeZone).get('year');
    const date2 = moment.tz(date, targetTimeZone).get('date');
    if (date1 !== date2) {
        const newDate = moment()
            .tz(targetTimeZone)
            .set({ month: month1, year: year1, date: date1 });
        return newDate.format();
    }
    return date;
}
export function getEntityResources(entityType, ui, u, ci, c, gi, g) {
    let resources = [];
    switch (entityType) {
        case 'user':
            resources = ui.map(x => {
                return {
                    // id: u.find(i => i.id == x).eventColor + '_fc' + k,
                    id: x,
                    title: u.find(i => i.id == x).name,
                    meta: x,
                };
            });
            break;
        case 'calendar':
            resources = ci.map(x => {
                var _a;
                return {
                    id: x,
                    title: (!((_a = c.find(i => i.id == x)) === null || _a === void 0 ? void 0 : _a.isActive) ? '(Drafted)' : '') +
                        ' ' +
                        c.find(i => i.id == x).name,
                    meta: x,
                };
            });
            break;
        case 'group':
            resources = gi.map(x => {
                var _a;
                return {
                    id: x,
                    title: (!((_a = g.find(i => i.id == x)) === null || _a === void 0 ? void 0 : _a.isActive) ? '(Drafted)' : '') +
                        ' ' +
                        g.find(i => i.id == x).calendarProviderName,
                    meta: x,
                };
            });
            break;
        default:
            resources = [];
            break;
    }
    return resources;
}
export function handleDuplicateForUserResource(resources, events) {
    const found = [];
    const final = [];
    for (const item of events) {
        if (!item.ogEvent.users || item.ogEvent.users.length === 0) {
            //
            final.push(Object.assign(Object.assign({}, item), { resourceId: item.ogEvent.assignedUserId }));
        }
        else {
            //
            item.ogEvent.users.forEach((r) => {
                const tf = r + item.ogEvent.id;
                if (found.indexOf(tf) === -1 && resources.indexOf(r) > -1) {
                    found.push(tf);
                    final.push(Object.assign(Object.assign({}, item), { resourceId: r }));
                }
            });
        }
    }
    return final;
}
export function getGMTOffset(timezone) {
    const offset = moment.tz(timezone).utcOffset();
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    const sign = offset < 0 ? '-' : '+';
    return `GMT ${sign}${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
}
